import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IUniversities } from "common/types/universities";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
        gallery:
          values?.gallery?.map((item: any) => item?.response?.data) || [],
        rankings: values?.rankings || [],
      };
      const response = await api.university.addUniversity(payload, id);
      message.success("Universitet yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.university.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IUniversities)[]
      ).map((key) => ({
        name: key,
        value:
          key === "gallery"
            ? response.data[key]?.map((item) => ({
                url: `${process.env.REACT_APP_BASE_URL}${item}`,
                response: { data: item },
              }))
            : response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.university.delete(id);
        message.success("Universitet o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const UniversitiesAddContext = createContext<any>({ state: {}, actions: {} });

export const UniversitiesAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <UniversitiesAddContext.Provider value={value}>
      {children}
    </UniversitiesAddContext.Provider>
  );
};

export default function useUniversitiesAddContext() {
  return useContext<ReturnType<typeof Context>>(UniversitiesAddContext);
}
